import { Redirect, useLocation } from "wouter";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { EmptyState, Loader } from "@threadws/jute";

/** Kinde sends you back here after sign-in. The SDK swaps the code for tokens itself. */
export function CallbackPage() {
  const { isLoading, isAuthenticated, error } = useKindeAuth();
  const [, navigate] = useLocation();

  if (error) {
    return (
      <EmptyState
        title="Sign-in failed"
        description={error}
        actionLabel="Try again"
        onAction={() => navigate("/sign-in", { replace: true })}
      />
    );
  }
  if (!isLoading && isAuthenticated) return <Redirect to="/" replace />;
  if (!isLoading) return <Redirect to="/sign-in" replace />;
  return <Loader label="Signing you in" />;
}
